(function(){
  function init(c){
    if(c.__noaDrag) return; c.__noaDrag=true;
    var track=c.firstElementChild; if(!track) return;
    var duration=parseFloat(c.getAttribute('data-duration'))||70;
    c.classList.add('is-drag');
    var half=0;
    function measure(){ half=track.scrollWidth/2; }
    measure();
    c.querySelectorAll('img').forEach(function(im){ if(!im.complete) im.addEventListener('load', measure, {once:true}); });
    window.addEventListener('resize', measure);
    var dragging=false, last=null, startX=0, startScroll=0, moved=false;
    function spd(){ return half>0 ? half/duration : 0; }
    function wrap(){ if(half<=0) return; if(c.scrollLeft>=half) c.scrollLeft-=half; else if(c.scrollLeft<0) c.scrollLeft+=half; }
    function loop(t){
      if(last==null) last=t;
      var dt=(t-last)/1000; last=t; if(dt>0.1) dt=0.016;
      if(!dragging) c.scrollLeft += spd()*dt;
      wrap();
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    c.addEventListener('pointerdown', function(e){
      dragging=true; moved=false; startX=e.clientX; startScroll=c.scrollLeft; last=null;
      c.classList.add('is-grabbing');
      if(e.pointerType!=='touch'){ try{ c.setPointerCapture(e.pointerId); }catch(_){} }
    });
    c.addEventListener('pointermove', function(e){
      if(!dragging) return;
      if(Math.abs(e.clientX-startX)>5) moved=true;
      if(e.pointerType!=='touch'){ c.scrollLeft=startScroll-(e.clientX-startX); wrap(); e.preventDefault(); }
    });
    function end(){ if(!dragging) return; dragging=false; last=null; c.classList.remove('is-grabbing'); }
    c.addEventListener('pointerup', end);
    c.addEventListener('pointercancel', end);
    c.addEventListener('pointerleave', function(e){ if(e.pointerType!=='touch') end(); });
    // suppress accidental link navigation right after a drag
    c.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } }, true);
    c.addEventListener('dragstart', function(e){ e.preventDefault(); });
    c.addEventListener('touchstart', function(){ dragging=true; }, {passive:true});
    c.addEventListener('touchend', function(){ dragging=false; last=null; }, {passive:true});
    c.addEventListener('touchcancel', function(){ dragging=false; last=null; }, {passive:true});
  }
  function run(){ document.querySelectorAll('.js-noa-drag').forEach(init); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();